import { isEmpty, isEqual, keyBy, mapValues, zip } from 'lodash';
import { getStore } from '@shared/store';
import { calculateMessageLayoutOptions } from './calculateMessageLayoutOptions';

/*
    Calculate message layout and update the store.
*/
export function layoutMessages(
  messages: MBAPI.ChatMessage[],
  readMarkers: MBAPI.ChannelChatThread['userReadMarkers'],
  myReadAt: moment.Moment | null,
) {
  return async (dispatch: MBDispatch) => {
    const store = getStore();
    // 1. Calculate layout options for the group of messages
    const messageLayoutOptions = calculateMessageLayoutOptions(messages, readMarkers, myReadAt);

    // 2. Loop through all the messages and layout options. If options have
    //    changed, update them in the store. Note, we want to update options
    //    only to the extent absolutely necessary. Therefore we don't dispatch
    //    all messages, just messages that have changed. This is for the
    //    performance reasons explained in MBChatThread.
    const messagesAndLayoutOptions = zip(messages, messageLayoutOptions);

    // 3. Only update the layout options if
    //    - it doesn't already exist or
    //    - some value has changed
    const needsLayoutUpdate = messagesAndLayoutOptions.filter(([message, layoutOptions]) => {
      const oldLayoutOptions: MBChatMessageLayoutOptions =
        store.getState().chatMessages.layoutOptionsFromMessageId[message?.id ?? ''];
      return !oldLayoutOptions || !isEqual(layoutOptions, oldLayoutOptions);
    });

    // 4. create an object keyed by message id
    const indexedByMessageId = keyBy(
      needsLayoutUpdate,
      ([message, _layoutOptions]) => message?.id ?? '',
    );

    // 5. map the object values to just layout options, discarding the messages
    const layoutOptionUpdates = mapValues(
      indexedByMessageId,
      ([_message, layoutOptions]) => layoutOptions,
    );

    if (!isEmpty(layoutOptionUpdates)) {
      dispatch({
        type: 'CHAT:UPDATE_MESSAGE_LAYOUT',
        value: { layoutOptions: layoutOptionUpdates },
      });
    }
  };
}
